import React from "react";

function IconCrossMarketDemand() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 3.369c.362 0 .656.293.656.656v9.844h12.907a.656.656 0 1 1 0 1.312H1.093V4.025c0-.363.295-.656.657-.656Z"
      />
      <path d="M1.75 5.994c0-.121.098-.22.219-.22h10.063c.12 0 .218.099.218.22V8.18c0 .121-.098.219-.218.219H1.969a.219.219 0 0 1-.219-.219V5.994ZM1.75 10.369c0-.121.098-.22.219-.22H6.78c.121 0 .22.099.22.22v2.187c0 .121-.099.219-.22.219H1.97a.219.219 0 0 1-.219-.219V10.37Z" />
    </svg>
  );
}

export default IconCrossMarketDemand;
